module.exports = __webpack_public_path__ + "static/media/exclamation-mark-triangle@3x.258534a0.png";